import { message } from 'antd'
import { useCallback, useState } from 'react'
import { updateCensusFileRows } from '../../api/census-enrollment-platform-api-client'
import { CensusFileRowDto } from '../../api/dto/census-file-row.dto'
import { CensusFileRowGridData } from '../../types/census-file-row-grid-data'
import { mapGridDataToCensusFileRowDto } from '../../utils/map-grid-data-to-census-file-row-dto'

interface UseCategoriseRowsParams {
  publicKey: string
  onComplete: () => void
  setPageLoading: (loading: boolean) => void
}

export function useCategoriseRows({
  publicKey,
  onComplete,
  setPageLoading,
}: UseCategoriseRowsParams) {
  const [loading, setLoading] = useState(false)

  const categorise = useCallback(
    async (rows: CensusFileRowGridData[]) => {
      setLoading(true)
      setPageLoading(true)

      try {
        const dtoRows: CensusFileRowDto[] = rows.map((gridRow) =>
          mapGridDataToCensusFileRowDto(gridRow)
        )
        await updateCensusFileRows(dtoRows, publicKey)
        message.success(
          `${rows.length} record(s) submitted for categorisation`,
          3
        )
      } catch (error) {
        const msg = `Failed to categorise records: '${(error as Error).message}'`
        console.error(msg)
        message.error(msg, 5)
      } finally {
        setLoading(false)
        setPageLoading(false)
        onComplete()
      }
    },
    [publicKey, onComplete, setPageLoading]
  )

  return { categorise, loading }
}
